import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;
  gap: 4px;
`

export const Header = styled.div`
  font-weight: 600;
`

export const List = styled.ol`
  display: grid;

  gap: 4px;

  margin-left: 18px;

  list-style: decimal;

  word-break: break-word;
`

export const Example = styled.p`
  font-size: 14px;
  color: ${Colors.GS700};
  word-break: break-all;
`
